export const PAYMENT_METHODS = [
  "Efectivo",
  "Deducción",
  "Transferencia",
  "Tarjeta de Crédito",
  "Tarjeta de Débito",
  "Sin definir",
];
